<template>
    <div class="search-block w-[90%] mx-auto">
        <div class="flex justify-between mt-2">
            <div class="flex py-[3px] items-center gap-4">
                <div class="search-bar flex items-center border-[#FFF] border-[1px] bg-[#FFF] bg-opacity-30 px-[10px] rounded-[6px]">
                    <img src="@/desktopApp/assets/icons/magnify_icon.svg" class="w-3 h-3">
                    <input v-model="search" class="text-[#FFF] text-[14px] bg-transparent rounded-md px-2 py-[3.5px] placeholder:text-[#FFF] outline-none w-[250px]" placeholder="Пошук..." type="text">
                </div>

                <div class="flex items-center text-[#FFF] text-[13px] gap-2">
                    <button
                        class="px-3 py-1 rounded-md border border-white border-opacity-30 hover:border-opacity-60 transition disabled:opacity-40"
                        @click="prevPage"
                        :disabled="page <= 1"
                    >
                        Назад
                    </button>
                    <div class="flex items-center gap-1 min-w-[110px] justify-center">
                        <span>Стор.</span>
                        <input
                            v-model.number="page"
                            type="number"
                            class="w-[56px] bg-transparent border border-white border-opacity-30 rounded px-2 py-1 text-center outline-none"
                            min="1"
                            :max="maxPage"
                        >
                        <span>/ {{ maxPage }}</span>
                    </div>
                    <button
                        class="px-3 py-1 rounded-md border border-white border-opacity-30 hover:border-opacity-60 transition disabled:opacity-40"
                        @click="nextPage"
                        :disabled="page >= maxPage"
                    >
                        Вперед
                    </button>
                </div>
            </div>
            <div class="filter flex items-center">
                <button class="bg-[#BD9135] hover:bg-[#a77f2b] w-[228px] text-white px-4 h-[38px] text-[14px] rounded-md" @click="$emit('addStudent')">Додати</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, watch } from 'vue'

    export default {
        name: 'menu-bar',

        emits: ['update:modelValue', 'startFilter', 'update:page'],

        props: {
            modelValue: {
                type: String,
                default: ''
            },
            page: {
                type: Number,
                default: 1
            },
            maxPage: {
                type: Number,
                default: 1
            }
        },

        setup(props, { emit }) {
            const search = ref(props.modelValue)
            const page = ref(props.page) 

            const prevPage = () => {
                page.value = page.value > 1 ? page.value - 1 : 1
            }

            const nextPage = () => {
                page.value = page.value < props.maxPage ? page.value + 1 : props.maxPage
            }

            watch(search, (value) => {
                emit('update:modelValue', value)
                emit('startFilter')
            })

            watch(page, (value) => {
                if (value >= props.maxPage) {
                    page.value = props.maxPage
                } else if (value <= 1 && value != '') {
                    page.value = 1
                } else if (value == ''){
                    return
                }
                emit('update:page', value)
                emit('startFilter')
            })

            watch(() => props.page, (value) => {
                if (value !== undefined && value !== page.value) {
                    page.value = value || 1
                }
            })

            watch(() => props.maxPage, (value) => {
                if (page.value > value) {
                    page.value = value || 1
                }
            })

            return {
                search,
                page,
                prevPage,
                nextPage
            }
        }
    }
</script>

<style lang="scss" scoped>

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

</style>
